import React , { useEffect }from 'react';
import config from '../../helpers/config';
import { makeStyles, useTheme } from '@material-ui/styles';
import { fetchFacilities } from '../actions';
import Helmet from '../components/Helmet';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Grid, Typography, CssBaseline, Container, Hidden } from '@material-ui/core';
import { useLocation, useParams } from 'react-router-dom'
import PageCover from '../components/PageCover'; 
import NumberList from '../components/NumberList';
import hash from '../../helpers/hash';
import BackgroundImage from '../components/BackgroundImage';
import { HashLink } from 'react-router-hash-link';

const useStyles = makeStyles(theme => ({
    facilityPage:  props => ({

    }),

    summary: props => ({
        textAlign: 'right',
        padding: '100px 50px 50px 50px',
        [theme.breakpoints.down("xs")]: {
            padding: '80px 20px 20px 20px',
        },
        '& h4' : {
            fontWeight: 400,
            color: hash.walk('theme.secondary', props),
            '& a': {
                textAlign: 'center',
                textDecoration: 'none',
                fontWeight: 'bold',
                color: hash.walk('theme.secondary', props),
                letterSpacing: '7px',
                paddingLeft: '7px',
                [theme.breakpoints.down("xs")]: {
                    letterSpacing: '2px',
                },
            }
        }
    }),

    facilityContent: props => ({

        '& .contentLeft': {
            borderRight: '1px solid black',
            paddingRight: '40px',
            paddingBottom: '100px',
            
            [theme.breakpoints.down("xs")]: {
                borderRight: 'none',
                paddingRight: '0px',
                paddingBottom: '50px',
            },

            '& .contentTitle': {

                '& > div': {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    padding: '10px 10px 10px 0px',
    
                    '& h4': {
                        fontWeight: 400
                    }
                }
            },
            '& .contentDesc': {

                '& > div': {
                    padding: '10px 10px 10px 0px',
    
                    '& h4': {
                        fontWeight: 400
                    }
                }
            },

            '& .contentImg': {
                '& > div': {
                    height: '500px',
                    padding: '20px 0px 20px 20px',
                    position: 'relative',

                    [theme.breakpoints.down("xs")]: {
                        height: '250px',
                    },

                    '& > div:first-child': {
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        height: '100%',
                    },
                    '& > div:last-child': {
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        height: '80%',
                        width: '90%',
                        borderLeft: '1px solid black',
                        borderBottom : '1px solid black'
                    }
                }
            }
        },

        '& .contentRight': {
            '& > div': {
                paddingLeft: '100px',
                height: 500,

                [theme.breakpoints.down("xs")]: {
                    paddingLeft: '0px',
                    display: 'none'
                },

                '& > div': {
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    height: '100%',
                }
            }
        }
    }),

}));


const FacilityPage = (props) => {
    
    const location = useLocation();
    const { id } = useParams();

    useEffect(() => {
        props.fetchFacilities(location.pathname);
    }, [id]);
    const facility = facility || props.facilities.filter(d => d.id === id)[0];
    const classes = useStyles(facility);
    const theme = useTheme();
    
    if (!facility) {
        return <div></div>
    }

    const PageCoverProps = {
        ...facility,
        style: {
            title: {
                position: 'absolute',
                top: 'auto',
                right: '0',
                bottom: '-50px',
                left: 'auto',
                width: '60%',
                backgroundColor: 'rgba(255,255,255,0.6)',
                fontWeight: '500',
                boxShadow: '1px 1px 10px #6f6f6f',
                [theme.breakpoints.down('xs')] : {
                    width: '95%',
                },
                '& .title': {
                    padding: '20px',
                    position: 'relative',
                    "& h3": {
                        letterSpacing: '7px',
                        paddingBottom: '20px'
                    }
                },
                '& .superTitle': {
                    textAlign: 'center',
                    borderLeft: '2px solid black',
                    '& h1': {
                        fontWeight: '300',
                        fontSize: '9vw',
                    },
                },
                '& .phone': {
                    backgroundColor: facility.theme.secondary,
                    padding: '80px 0px',
                    textAlign: 'center',
                    [theme.breakpoints.down("xs")]: {
                        padding: '10px 0px',
                    },
                    '& h4 a': {
                        color: 'white',
                        fontWeight: '300',
                        lineHeight: '200%',
                        textDecoration: 'none',
                        [theme.breakpoints.down("xs")]: {
                            display: 'inline-block'
                        },
                    },
                    '& h4:first-child': {
                        letterSpacing: '10px',
                        paddingLeft: '10px'
                    },
                    '& hr': {
                        width: '33%',
                        margin: '20px auto 0px auto',
                        [theme.breakpoints.down("xs")]: {
                            display: 'none'
                        },
                    }
                }
            }
        }
    };

    return (
        <React.Fragment>
            
            <Helmet {...facility} />
            <div className={classes.facilityPage}>
                <PageCover {...PageCoverProps} > 
                    <Grid container justify="center" alignItems="center" >
                        <Grid item xs={12} sm={6} className="title">
                            <Typography variant="h3">
                                <b>{facility.shortenName}</b>
                            </Typography>
                            <Typography variant="h4">{facility.desc}</Typography>
                        </Grid>
                        <Grid item xs={false} sm={3} className="superTitle">
                            <Hidden smDown={true} implementation="css"><Typography variant="h1">{facility.floor_en}</Typography></Hidden>
                        </Grid>
                        <Grid item xs={12} sm={3} className="phone">
                            <Typography variant="h4"><a href="tel: 066379888">{facility.phoneTitle}</a></Typography>
                            <Typography variant="h4"><a href={`tel: ${facility.phone}`}>{facility.phone}</a></Typography>
                            <hr></hr>
                        </Grid>
                    </Grid>
                </PageCover>
                
                <div className={classes.summary}>
                    <Grid item xs={12}> 
                        <Typography variant="h4">
                            {facility.children.map((d, i) => {
                                return <span key={i}> | <HashLink to={`#${d.id}`} scroll={el => el.scrollIntoView({ behavior: 'smooth' })}>{d.name} </HashLink> </span>
                            })} |
                        </Typography>
                    </Grid>
                </div>

                <Container maxWidth="xl">
                    <div className={classes.facilityContent}>
                        {facility.children.map((d, i) => {
                            const size = '30px',
                                contentProps = {
                                    style: {
                                        color: 'white',
                                        backgroundColor: hash.walk('theme.secondary', facility),
                                        fontWeight: 500,
                                        height: size,
                                        width: size,
                                        textAlign: 'center',
                                        lineHeight: size
                                    }
                                }
                            return (<Grid key={i} container id={d.id}>
                                <Grid container item xs={12} sm={8} className={'contentLeft'}>
                                    <Grid item xs={12} className={'contentTitle'}>
                                        <div><NumberList {...contentProps}> {i + 1} </NumberList></div>
                                        <div><Typography variant="h4"><b>{d.name}</b></Typography></div>
                                        <div><Hidden xsUp={true} implementation="css"><sub>({d.hours})</sub></Hidden></div>
                                    </Grid>
                                    <Grid item xs={12} className={'contentDesc'}>
                                        <div><Typography variant="h5">&#10022; {d.desc}</Typography></div>
                                    </Grid>
                                    <Grid item xs={12} className={'contentImg'}>
                                        <div>
                                            <div style={{backgroundImage: 'url(' + config.S3Endpoint + d.imgUrl + ')'}}></div>
                                            <div></div>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={4} className={'contentRight'}>
                                    <div>
                                        <div style={{backgroundImage: 'url(' + config.S3Endpoint + d.floorPlan + ')'}}></div>
                                    </div>
                                </Grid>
                            </Grid>)
                            
                        })}

                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
}


function mapStateToProps({ facilities }) {
    return { facilities };
}

export default {
    loadData: ({ dispatch }) => dispatch(fetchFacilities()),
    component:  connect(mapStateToProps, { fetchFacilities }) (FacilityPage)
}


// WEBPACK FOOTER //
// ./src/client/pages/FacilityPage.js